import styled from 'styled-components';
import React, { FC } from 'react';
import { DeveloperContactProps } from './types';

interface DeveloperContactLinkProps extends DeveloperContactProps {
}

const StyledLink = styled.a``;

export const DeveloperContactLink: FC<DeveloperContactLinkProps> = ({
  label,
  onClick,
  id,
  href,
  target,
}) => (
  <StyledLink
    href={href}
    target={target}
    id={id}
    aria-label={id}
    onClick={onClick}
  >{label}</StyledLink>
);